export const getEmployeeCoveragePath = (employeePublicKey?: string) =>
  employeePublicKey ? `/employees/${employeePublicKey}/coverage` : undefined

export const getClientViewPath = (clientPublicKey?: string) =>
  clientPublicKey ? `/customer-management/${clientPublicKey}/view` : undefined

export const getEnrollmentCartPath = (
  employeePublicKey?: string,
  enrollmentPublicKey?: string
) =>
  employeePublicKey && enrollmentPublicKey
    ? `/employees/${employeePublicKey}/enrollments/${enrollmentPublicKey}/cart`
    : undefined

/**
 * The application's own detail page — the screen operators call "App Engine",
 * and the destination Payment assignment's "App Engine Link" already opens
 * (`PaymentDetailModal/EmployeeInformationSection.tsx`).
 *
 * The route resolves on the BENEFIT INSTANCE row id (`benefits."Id"`), which is
 * what reconciliation calls `benefitId` and what Application engine's own grid
 * pops for a row (`ApplicationEngineContentTable.tsx`). The parameter name
 * below predates those callers and is a misnomer; it is left alone rather than
 * churned through its QLE caller.
 *
 * No query string, no date window: this is one application by id, not a search
 * over a filtered list.
 */
export const getApplicationDetailsPath = (benefitPublicKey: string) =>
  `/application-manager/${benefitPublicKey}`

export const getApplicationEngineSearchPath = (enrollmentPublicKey?: string) =>
  enrollmentPublicKey
    ? `/application-engine?search=${encodeURIComponent(enrollmentPublicKey)}`
    : undefined
